import nanoid from 'nanoid';

const FIELDS = ['country-name'];

export const autocomplete = field => {
  if (FIELDS.includes(field)) {
    return nanoid();
  }

  return field;
};



// WEBPACK FOOTER //
// ./utils/autocomplete.js